module.exports = new __parcel__URL__("benefits_2.6ca1854b.webp").toString();